/* src/app/components/analytics/case-notes/case-notes-list/case-notes-list.component.scss */
mat-list-item {
  --delete-button__display: none;
  --delete-button__on-hover: block;
}
mat-icon.shared {
  background: #ffcdd2;
}
.search-item-disclaimer {
  background: #9fa8da;
  padding: 14px 16px;
  margin: 10px auto;
  border-radius: 3px;
}
/*# sourceMappingURL=case-notes-list.component.css.map */
